export const TAX_CODE_RE = /^([A-Z0-9]{16}|\d{11})$/;

export const emptyJobForm = () => ({
  kind: "intervento", equipment_type: "", brand_model: "", notes: "", photos: [],
  first_name: "", last_name: "", email: "", phone: "", address: "", city: "", tax_code: "",
  lat: null, lng: null, date: "", start: "", end: "", technician_id: "", dates: [], helper_ids: [],
});

export function serviceError(f) {
  if (f.kind === "intervento") {
    if (!f.equipment_type) return "Seleziona il tipo di apparecchiatura";
    if (!f.brand_model.trim() && !f.photos.length) return "Indica marca/modello oppure carica una foto";
  }
  return null;
}

export function contactError(f, requireGeo = true) {
  if (!f.first_name.trim() || !f.last_name.trim()) return "Inserisci nome e cognome";
  if (!/^\S+@\S+\.\S+$/.test(f.email)) return "Email non valida";
  if (f.phone.replace(/\D/g, "").length < 6) return "Numero di telefono non valido";
  if (!f.address.trim() || !f.city.trim()) return "Inserisci indirizzo e comune";
  if (f.tax_code && !TAX_CODE_RE.test(f.tax_code.trim().toUpperCase())) return "Codice fiscale (16 caratteri) o partita IVA (11 cifre) non valido";
  if (requireGeo && (f.lat == null || f.lng == null)) return "Rileva la posizione o cercala dall'indirizzo";
  return null;
}

export const scheduleError = (f) => (!f.date || !f.start || !f.end ? "Seleziona giorno e fascia oraria" : null);

export const toPayload = (f) => ({
  kind: f.kind,
  first_name: f.first_name.trim(), last_name: f.last_name.trim(), email: f.email.trim(), phone: f.phone.trim(),
  address: f.address.trim(), city: f.city.trim(), tax_code: (f.tax_code || "").trim().toUpperCase() || null, lat: f.lat, lng: f.lng,
  equipment_type: f.kind === "sopralluogo" ? null : f.equipment_type || null,
  brand_model: f.brand_model.trim() || null, warranty: !!f.warranty, notes: f.notes.trim() || null,
  error_photo_ids: f.photos.map((p) => p.file_id),
  date: f.date, start: f.start, end: f.end, dates: f.dates || [],
  technician_id: f.technician_id || null,
  helper_ids: f.technician_id ? (f.helper_ids || []).filter((h) => h !== f.technician_id) : [],
});
